import type { FaireProductEntity } from "../../entity_types/product";

export const p_75y3yntsrq: FaireProductEntity = {
  token: "p_75y3yntsrq",
  type: "product",
  name: "Precious Gems & Crystals 100% HW Cotton Adult T-shirt",
  brandToken: "b_ihxgqwki5y",
  brandName: "Atlas Screen Printing",
  imageUrl:
    "https://cdn.faire.com/fastly/ba0900e17528e2d4fdda7f4fc61722708359b11661b11c17e2e162c3bf7638b6.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.86,
  description:
    "This WILD COTTON® 100% HW Cotton Adult T-shirt is decorated with our original screen printed art is comfortable to wear, safe to wash and will last for years.",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:48.720Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
